<template>
<div class="info">
	<div class="van-nav-bar van-hairline--bottom custom-nav-bar">
		<div class="van-nav-bar__content">
			<div class="van-nav-bar__left van-haptics-feedback"  @click="back()">
				<i class="van-badge__wrapper van-icon van-icon-arrow-left van-nav-bar__arrow"></i>
			</div>
			<div class="van-nav-bar__title van-ellipsis">
				{{$t('mine.infomation')}}
			</div>
		</div>
	</div>
	
	<div class="content-wrapper">
		<van-cell-group class="custom-cell-group">
			<van-cell :title="$t('infomation.username')" :value="userInfo.username" is-link />
			<van-cell :title="$t('infomation.name')" :value="userInfo.name" is-link  @click="toSetName()" />
			<van-cell :title="$t('infomation.bankcard')" :value="$t('common.disable')" is-link  @click="toSetBank()" />
			<!-- <van-cell :title="$t('infomation.phone')" :value="userInfo.phone" is-link  @click="toSetSex()"/> -->
		</van-cell-group>
	</div>
</div>
</template>

<script>
export default {
  data() {
    return {
      isActive:false,
      show:false,
      isBank:false,
      userInfo:{}
    };
  },
  methods: {
    back(){
      return window.history.back();
    },
    toSetName(){
      this.$router.push({path:'/Setname'});
    },
    toSetBank(){
      this.$router.push({path:'/Setbank'});
    },
    toSetSex(){
      this.$router.push({path:'/Setsex'});
    },
    openHerderImg(){
      this.show = true;
    },
    select_header_img(url){
        this.isActive = url;
    },
    check(){
      this.$http({
        method: 'post',
        data:{header_img:this.isActive},
        url: 'user_header_img'
      }).then(res=>{
        if(res.code === 200){
          this.getUserInfo();
          this.$toast(res.msg);
          this.show = false;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserInfo(){
      this.$http({
        method: 'get',
        url: 'user_info'
      }).then(res=>{
        if(res.code === 200){
          this.userInfo = res.data;
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    },
    getUserBankInfo(){
      this.$http({
        method: 'get',
        url: 'user_get_bank'
      }).then(res=>{
        if(res.code === 200){
          if(res.data.is_bank){
            this.isBank = true;
          }else {
            this.isBank = false;
          }
        }else if(res.code ===401){
          this.$toast(res.msg);
        }
      })
    }
  },
  created() {
    if(!localStorage.getItem('token')){
      this.$router.push({path:'/Login'})
    }else {
      this.getUserInfo();
      this.getUserBankInfo();
    }
  }
};
</script>

<style lang='less' scoped>
:export {
    gbcolor: linear-gradient(135deg, #3498db, #8e44ad)
}

.info {
    width: 100%;
    min-height: 100vh;
    background: white;
    position: relative;
}

/* 顶部导航栏样式 - 填充颜色 */
.custom-nav-bar {
    height: 3.5rem;
    line-height: 3.5rem;
    background: linear-gradient(135deg, #3498db 0%, #8e44ad 100%);
    position: relative;
    z-index: 10;
}

.custom-nav-bar::after {
    display: none;
}

.van-nav-bar__title {
    max-width: 60%;
    margin: 0 auto;
    color: white;
    font-weight: 600;
    font-size: 1.1rem;
}

.van-nav-bar__left {
    padding: 0 15px;
}

.van-nav-bar__arrow {
    color: white;
    font-size: 1.2rem;
    font-weight: bold;
}

/* 内容区域样式 */
.content-wrapper {
    padding: 1.5rem 1rem;
    position: relative;
    z-index: 1;
    background: white;
}

.custom-cell-group {
    border-radius: 12px;
    overflow: hidden;
    background: white;
}

/* 每个单元格带边框 */
.van-cell {
    padding: 1.2rem 1.2rem;
    background: white;
    position: relative;
    border: 1px solid #e8e8e8;
    margin-bottom: 8px;
    border-radius: 8px;
    transition: all 0.3s ease;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.03);
}

.van-cell:last-child {
    margin-bottom: 0;
}

.van-cell:active {
    background-color: #f8f9ff;
    border-color: #667eea;
    transform: translateY(1px);
}

.van-cell__title {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    color: #333;
    font-weight: 500;
    font-size: 0.95rem;
}

.van-cell__title img {
    width: 1.5rem;
    margin-right: 8px;
}

.van-cell__value {
    color: #667eea;
    line-height: 1.2rem;
    height: 1.2rem;
    font-weight: 500;
    font-size: 0.9rem;
}

.van-cell__right-icon {
    color: #764ba2;
    font-size: 1rem;
}

/* 移除默认的单元格组边框 */
.van-cell-group::after,
.van-cell-group::before {
    display: none;
}

.van-cell::after {
    display: none;
}

/* 响应式调整 */
@media (max-width: 320px) {
    .content-wrapper {
        padding: 1rem 0.8rem;
    }
    
    .van-cell {
        padding: 1rem 1rem;
    }
}

/* 动画效果 */
@keyframes fadeInUp {
    from { 
        opacity: 0; 
        transform: translateY(15px); 
    }
    to { 
        opacity: 1; 
        transform: translateY(0); 
    }
}

.custom-cell-group .van-cell {
    animation: fadeInUp 0.4s ease forwards;
}

.custom-cell-group .van-cell:nth-child(1) { animation-delay: 0.1s; }
.custom-cell-group .van-cell:nth-child(2) { animation-delay: 0.2s; }
.custom-cell-group .van-cell:nth-child(3) { animation-delay: 0.3s; }
.custom-cell-group .van-cell:nth-child(4) { animation-delay: 0.4s; }

/* 页面标题样式 */
.page-title {
    font-size: 1.3rem;
    font-weight: 600;
    color: #333;
    margin-bottom: 1.5rem;
    padding: 0 0.5rem;
}
</style>